import { SimulatorChannel } from "@/api/simulator/simulator.model";

export function useTrainingAdditionalContextEnabled(
  channel?: SimulatorChannel
) {
  return (
    (channel === "autonomous_ticket_event" ||
      channel === "autonomous_quackchat")
  );
}
